import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

function useItem(itemId: string) {
    const { data, status } = useQuery(queries.items.detail(itemId));
    const toast = useToast();
    const { pop } = useFlow();
    useEffect(() => {
        if (status === 'error') {
            toast.error('상품 정보를 가져오는 중 오류가 발생했습니다.');
            pop();
        }
    }, [status, pop, toast]);
    return data;
}

export default useItem;
